import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import useLocation from "../../../containers/FacilityDetailsPage/hooks/useLocation";
import { LocalPostData } from "../../../models/LocalPostData";
import { OptionalRender } from "../../Common/OptionalRender";
import { ModalLocalPostIdeas } from "../ModalLocalPostIdeas";
import { UpdateGbpLocalPostForm } from "../UpdateGbpLocalPostForm";

import "./styles.scss";

export interface IModalUpdateGbpLocalPostProps {
  onClose: () => void;
  localPost: LocalPostData;
  onSuccess?: () => void;
}

export const ModalUpdateGbpLocalPost: React.FunctionComponent<
  IModalUpdateGbpLocalPostProps
> = (props) => {
  const { onClose, localPost, onSuccess } = props;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`analysisCollectionsPage.modalUpdateLocalPost.${key}`);

  const { data: locationData } = useLocation(localPost.location_id.toString());

  const [shownModalLocalPostIdeas, setShownModalLocalPostIdeas] =
    useState<boolean>(false);

  return (
    <div className="modal modal-default modal-update-gbp-local-post">
      <div className="modal-mains">
        <button className="btn-close" onClick={onClose}></button>
        <div className="modal-mains__body">
          <div className="top-title update-gbp-top-title">
            <h2>{t("title")}</h2>
            <OptionalRender mustBeImpersonating={true}>
              <button
                className="btn btn-border"
                onClick={() => setShownModalLocalPostIdeas(true)}
              >
                {t("get_ideas")}
              </button>
            </OptionalRender>
          </div>

          <UpdateGbpLocalPostForm
            localPost={localPost}
            onClose={onClose}
            onSuccess={onSuccess}
          />

          {shownModalLocalPostIdeas && locationData && (
            <ModalLocalPostIdeas
              locationData={locationData}
              onClose={() => setShownModalLocalPostIdeas(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalUpdateGbpLocalPost;
